"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBounded = makeBounded;
const tslib_1 = require("tslib");
// it's safe to use any there because it won't leave this function
/* eslint-disable @typescript-eslint/no-explicit-any, import/no-cycle */
const stacktraceJs = tslib_1.__importStar(require("stacktrace-js"));
const errors_deprecated_1 = require("../errors-deprecated");
const debug_1 = require("./debug");
function getAllDescriptors(obj) {
    let descriptors = {};
    let curr = obj;
    while (curr != null && curr !== Object.prototype) {
        descriptors = { ...Object.getOwnPropertyDescriptors(curr), ...descriptors };
        curr = Object.getPrototypeOf(curr);
    }
    return descriptors;
}
const lastDisposeCall = new WeakMap();
function wrapDisposeCheck(target, method) {
    return function disposeCheck(...args) {
        var _a;
        if (typeof target === "object" && target.isDisposed) {
            const stFrames = lastDisposeCall.get(target);
            const stacktrace = stFrames == null ? "" : (0, debug_1.formatStacktrace)(stFrames);
            const err = new errors_deprecated_1.DisposedObjectError("call on the disposed object", {
                className: (_a = target.constructor.displayName) !== null && _a !== void 0 ? _a : target.constructor.name,
                method: method.name,
            });
            if (typeof target.ctx === "object" &&
                typeof target.ctx.logger === "object" &&
                typeof target.ctx.logger.error === "function") {
                target.ctx.logger.error(err.message, { err, target: target.name, method: method.name, stacktrace });
            }
            else {
                throw err;
            }
        }
        return method.apply(target, args);
    };
}
function wrapTraceCollect(target, method) {
    return function traceCollect(...args) {
        stacktraceJs.get().then((st) => {
            lastDisposeCall.set(target, st);
        });
        return method.apply(target, args);
    };
}
function getName(klass) {
    return String("displayName" in klass.constructor ? klass.constructor.displayName : klass.constructor.name);
}
function makeBounded(target, exclude = [], debug = false) {
    var _a, _b, _c;
    if (target == null || typeof target !== "object") {
        throw new Error("bindMethods works only on objects");
    }
    const allDescriptors = getAllDescriptors(target);
    const keys = Object.keys(allDescriptors).filter((k) => !exclude.includes(k));
    for (const key of keys) {
        const ownDesc = Object.getOwnPropertyDescriptor(target, key);
        const protoDesc = allDescriptors[key];
        const method = protoDesc.value;
        if (typeof method === "function" && key !== "constructor" && (ownDesc == null || ownDesc.configurable)) {
            let wrapper = method.bind(target);
            Reflect.defineProperty(wrapper, "name", { configurable: true, value: getName(target) + "." + method.name });
            if (debug) {
                if (key === "dispose") {
                    wrapper = wrapTraceCollect(target, method);
                }
                else {
                    wrapper = wrapDisposeCheck(target, method);
                }
            }
            Object.defineProperty(target, key, {
                value: wrapper,
                configurable: (_a = ownDesc === null || ownDesc === void 0 ? void 0 : ownDesc.configurable) !== null && _a !== void 0 ? _a : true,
                enumerable: (_b = ownDesc === null || ownDesc === void 0 ? void 0 : ownDesc.writable) !== null && _b !== void 0 ? _b : false,
                writable: (_c = ownDesc === null || ownDesc === void 0 ? void 0 : ownDesc.writable) !== null && _c !== void 0 ? _c : false,
            });
        }
    }
    return target;
}
//# sourceMappingURL=bind.js.map